/**
 * Lista canonica delle regioni italiane, con coordinate centrali (per
 * centrare la mappa quando l'utente sceglie la regione gratis) e short
 * summary (n. POI nel DB, calcolato runtime).
 */

import type { POI } from "../types";

export interface RegionInfo {
  name: string;
  center: { lat: number; lng: number };
  zoom: number;
}

/** Ordine alfabetico (per UI del picker). */
export const ITALIAN_REGIONS: RegionInfo[] = [
  { name: "Abruzzo",                center: { lat: 42.354, lng: 13.398 }, zoom: 8 },
  { name: "Basilicata",             center: { lat: 40.638, lng: 15.806 }, zoom: 8 },
  { name: "Calabria",               center: { lat: 38.910, lng: 16.587 }, zoom: 8 },
  { name: "Campania",               center: { lat: 40.840, lng: 14.250 }, zoom: 8 },
  { name: "Emilia-Romagna",         center: { lat: 44.494, lng: 11.342 }, zoom: 8 },
  { name: "Friuli-Venezia Giulia",  center: { lat: 46.063, lng: 13.236 }, zoom: 9 },
  { name: "Lazio",                  center: { lat: 41.893, lng: 12.483 }, zoom: 8 },
  { name: "Liguria",                center: { lat: 44.411, lng: 8.933 },  zoom: 9 },
  { name: "Lombardia",              center: { lat: 45.466, lng: 9.190 },  zoom: 8 },
  { name: "Marche",                 center: { lat: 43.616, lng: 13.518 }, zoom: 8 },
  { name: "Molise",                 center: { lat: 41.560, lng: 14.668 }, zoom: 9 },
  { name: "Piemonte",               center: { lat: 45.070, lng: 7.687 },  zoom: 8 },
  { name: "Puglia",                 center: { lat: 41.125, lng: 16.866 }, zoom: 8 },
  { name: "Sardegna",               center: { lat: 40.123, lng: 9.013 },  zoom: 8 },
  { name: "Sicilia",                center: { lat: 37.601, lng: 14.015 }, zoom: 8 },
  { name: "Toscana",                center: { lat: 43.770, lng: 11.255 }, zoom: 8 },
  { name: "Trentino-Alto Adige",    center: { lat: 46.499, lng: 11.357 }, zoom: 8 },
  { name: "Umbria",                 center: { lat: 43.111, lng: 12.388 }, zoom: 9 },
  { name: "Valle d'Aosta",          center: { lat: 45.737, lng: 7.320 },  zoom: 9 },
  { name: "Veneto",                 center: { lat: 45.438, lng: 12.327 }, zoom: 8 },
];

/** Conta i POI per ogni regione (utile per mostrare "X locali" nel picker). */
export function countPoiByRegion(pois: POI[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const p of pois) {
    if (!p.region) continue;
    counts[p.region] = (counts[p.region] || 0) + 1;
  }
  return counts;
}
